import { Route, Routes } from "react-router-dom";
import RequireAdminAccess from "./higher-order/require-admin-access";
import AdminCandidatesPage from "./pages/admin/admin-candidates.page";
import AdminUsersPage from "./pages/admin/admin-users.page";
import AdminViewCandidatePage from "./pages/admin/admin-view-candidate.page";
import AdminViewUserPage from "./pages/admin/admin-view-user.page";
import HomePage from "./pages/home.page";
import ProfilePage from "./pages/settings/profile.page";
import ChangePasswordPage from "./pages/settings/security/change-password.page";
import SubscriptionsPage from "./pages/settings/subscriptions/subscriptions.page";
export const AuthenticatedRoutes = () => {
  const adminRoutes = (
    <RequireAdminAccess>
      <Routes>
        <Route path="users/:username" element={<AdminViewUserPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="candidates/:cid" element={<AdminViewCandidatePage />} />
        <Route path="candidates" element={<AdminCandidatesPage />} />
      </Routes>
    </RequireAdminAccess>
  );

  const settingsRoutes = (
    <Routes>
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route path="/profile" element={<ProfilePage />} />
    </Routes>
  );

  return (
    <>
      <Routes>
        <Route path="/home" element={<HomePage />} />
        <Route path="/subscriptions" element={<SubscriptionsPage />} />
        <Route path="/settings/*" element={settingsRoutes} />
        <Route path="/admin/*" element={adminRoutes} />
      </Routes>
    </>
  );
};
